<template>
  <div>
    <h6 v-if="VALUE == '2'" class="text-primary"
      style="font-weight: 400; margin: 0px !important; padding: 0px !important">
      Ürün Trendyola Gönderilmiş ({{ params.data.eklenmeDurumu }})
    </h6>
    <h6 v-else-if="VALUE == '1'" class="text-primary"
      style="font-weight: 400; margin: 0px !important; padding: 0px !important">
      <vs-button @click="activePrompt = true" color="danger" radius size="small" icon="remove" type="gradient"
        v-b-tooltip.hover.bottom="'Alt Listeden Kaldır'"> </vs-button>
    </h6>
    <!--  v-if="params.data.eklenmeDurumu == 'anaUrun'" -->
    <h6 class="text-primary"
      style="font-weight: 400; margin: 0px !important; padding: 0px !important">
      <span v-if="VALUE == '-1'">
        <vs-button @click="addSubStockList(params.data)" radius size="small" icon="check" type="gradient" color="success"
          v-b-tooltip.hover.bottom="'Alt Ürün Ekle'"></vs-button>
      </span>
    </h6>

    <vs-prompt color="danger" title="Listenden Kaldırılacak Emin misiniz ?" acceptText="Sil" cancelText="Vazgeç"
      @accept="removeSubList(params.data.stokKodu)" :active.sync="activePrompt">
    </vs-prompt>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activePrompt: false,
      VALUE: "",
    };
  },
  methods: {
    removeSubList(data) {
      this.$root.$emit("removeSubList", data);
    },
    addSubStockList(data) {
      this.$root.$emit("addSubStockList", data);

    }
  },
  created() {
    this.VALUE = this.params.value;
  },
};
</script>
    